const highlight = {
	match: (text: string, query: string): Array<Array<number>> => {
		const idx = text.toLowerCase().indexOf(query.toLowerCase());

		return idx !== -1 ? [[idx, idx + query.length]] : [];
	},
	parse: (text: string, matches: Array<Array<number>>) => {
		const result = [];

		matches.forEach(match => {
			result.push(
				{ text: text.substring(0, match[0]), highlight: false },
				{ text: text.substring(match[0], match[1]), highlight: true },
				{ text: text.substring(match[1], text.length), highlight: false }
			);
		});

		return result;
	}
};

const formatCurrency = (value: number, code: string = 'RUR', locale: string = 'ru', fractions: number = 2): string => {
	const getCurrencyCode = (symbolicCode: string) => {
		const currencyUnitsByCode = {
			USD: 'USD',
			EUR: 'EUR',
			RUR: 'RUB',
			JPY: 'JPY',
			GBP: 'GBP'
		};

		return currencyUnitsByCode[symbolicCode]
			? currencyUnitsByCode[symbolicCode]
			: currencyUnitsByCode['RUR'];
	};

	return new Intl.NumberFormat(
		locale,
		{
			style: 'currency',
			currency: getCurrencyCode(code),
			minimumFractionDigits: fractions,
			maximumFractionDigits: fractions
		}
	).format(value);
};

// [single, few, many]
const declOfNum = (number: number, titles: [string, string, string]) => { 
	const cases = [2, 0, 1, 1, 1, 2];
	return titles[ (number % 100 > 4 && number % 100 < 20) ?  2 : cases[ (number % 10 < 5) ? number % 10 : 5 ] ];
}

function getPropInSafe<O, T>(obj: O, fn: (x: O) => T, replacer: any = undefined): T {
	try {
		const value = fn(obj);

		return typeof value !== 'undefined' ? value : replacer;
	} catch (err) {
		return replacer;
	}
}

function deepClone(obj: any) {
  const isObject = typeof obj === 'object';
  const isFunction = typeof obj === 'function';
  const copyObj = isObject
    ? Array.isArray(obj)
      ? [...obj]
      : Boolean(obj)
      ? { ...obj }
      : obj
    : isFunction
    ? function() {
        return obj.apply(this, arguments);
      }
    : obj;
  const clonePropsFn = (prop: string) =>
    (copyObj[prop] = deepClone(copyObj[prop]));

  Boolean(copyObj) && isObject && Object.keys(copyObj).forEach(clonePropsFn);

  return copyObj;
}

export {
	highlight,
	formatCurrency,
	declOfNum,
	getPropInSafe,
	deepClone,
};
